import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.7" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.5 5.43699C4.36261 5.21497 5 4.43192 5 3.5C5 2.39543 4.10457 1.5 3 1.5C1.89543 1.5 1 2.39543 1 3.5C1 4.43192 1.63739 5.21497 2.5 5.43699V6.5C2.5 7.88071 3.61929 9 5 9H7.06301C7.28503 9.86261 8.06808 10.5 9 10.5C10.1046 10.5 11 9.60457 11 8.5C11 7.39543 10.1046 6.5 9 6.5C8.06808 6.5 7.28503 7.13739 7.06301 8H5C4.17157 8 3.5 7.32843 3.5 6.5V5.43699ZM3 4.5C3.55228 4.5 4 4.05228 4 3.5C4 2.94772 3.55228 2.5 3 2.5C2.44772 2.5 2 2.94772 2 3.5C2 4.05228 2.44772 4.5 3 4.5ZM9 9.5C9.55228 9.5 10 9.05228 10 8.5C10 7.94772 9.55228 7.5 9 7.5C8.44772 7.5 8 7.94772 8 8.5C8 9.05228 8.44772 9.5 9 9.5Z",
        fill: "#3F3F46"
      })
    ], -1)
  ])))
}
export default { render: render }